function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, r) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.TinyRouter = r() : t.TinyRouter = r();
}(window, function () {
  return n = {}, o.m = e = [function (t, r, e) {
    "use strict";

    e.r(r), e.d(r, "getInstance", function () {
      return s;
    });

    function a(t) {
      var r = t.split("#"),
          e = r[0],
          n = r[1],
          o = void 0 === n ? "" : n,
          u = e.split("?"),
          i = u[0],
          a = u[1],
          f = void 0 === a ? "" : a,
          c = i.split("//"),
          l = c[0],
          s = c[1];
      s || (s = l, l = "");
      var p = s.split("@"),
          h = p[0],
          v = p[1];
      v || (v = h, h = "");
      var d = h.split(":"),
          y = d[0],
          b = d[1],
          g = void 0 === b ? "" : b,
          m = v.split("/"),
          j = m[0],
          O = m.slice(1),
          x = j.split(":"),
          w = x[0],
          P = void 0 === w ? "" : w,
          _ = x[1];
      return {
        href: t,
        protocol: l,
        host: P,
        port: void 0 === _ ? "" : _,
        pathname: O.length ? "/" + O.join("/") : "",
        search: f ? "?" + f : "",
        hash: o ? "#" + o : "",
        username: y,
        password: g
      };
    }

    function f(t, r) {
      function e(t) {
        return t.split("/").filter(function (t) {
          return !!t;
        });
      }

      var n = e(t),
          o = e(r);
      if (n.length !== o.length) return null;
      var u = "/" + n.join("/"),
          i = "/" + o.join("/"),
          a = u.match(/\:[a-zA-Z0-9_]+/g);
      if (null === a) return u === i ? {} : null;
      var f = u;
      a.forEach(function (t) {
        f = f.replace(t, "([a-zA-Z0-9]+)");
      });
      var c = i.match(f);
      return null !== c ? a.reduce(function (t, r, e) {
        return t[r.replace(":", "")] = c[e + 1], t;
      }, {}) : null;
    }

    function c(t, r) {
      function e(t) {
        return t.replace("?", "").split("&").reduce(function (t, r) {
          var e,
              n = r.split("="),
              o = n[0],
              u = n[1];
          return o ? _l(_l({}, t), ((e = {})[o] = decodeURIComponent(null != u ? u : ""), e)) : t;
        }, {});
      }

      var n = {},
          o = e(t),
          u = e(r);
      return Object.keys(o).forEach(function (t) {
        if (":" === o[t][0]) {
          var r = o[t].substr(1);
          n[r] = u[t] ? u[t] : null;
        }
      }), Object.keys(n).map(function (t) {
        return n[t];
      }).filter(function (t) {
        return null === t;
      }).length ? null : n;
    }

    var _l = function l() {
      return (_l = Object.assign || function (t) {
        for (var r, e = 1, n = arguments.length; e < n; e++) {
          for (var o in r = arguments[e]) {
            Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
          }
        }

        return t;
      }).apply(this, arguments);
    },
        _n = function n() {
      return (_n = Object.assign || function (t) {
        for (var r, e = 1, n = arguments.length; e < n; e++) {
          for (var o in r = arguments[e]) {
            Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
          }
        }

        return t;
      }).apply(this, arguments);
    },
        u = function u() {
      for (var t = 0, r = 0, e = arguments.length; r < e; r++) {
        t += arguments[r].length;
      }

      var n = Array(t),
          o = 0;

      for (r = 0; r < e; r++) {
        for (var u = arguments[r], i = 0, a = u.length; i < a; i++, o++) {
          n[o] = u[i];
        }
      }

      return n;
    },
        o = (i.prototype.addRoute = function (t, r, e) {
      this.routes = u(this.routes, "string" == typeof t ? [{
        name: name,
        pattern: "" + this.prefix + r,
        actions: e
      }] : [_n(_n({}, t), {
        pattern: "" + this.prefix + t.pattern
      })]);
    }, i.prototype.addRoutes = function (t) {
      var r = this;
      this.routes = u(this.routes, t.map(function (t) {
        return _n(_n({}, t), {
          pattern: "" + r.prefix + t.pattern
        });
      }));
    }, i.prototype.resolve = function (n) {
      var o = this;
      return new Promise(function (r, t) {
        var e = o.routes.reduce(function (t, r) {
          var e = function (t, r) {
            var e = a(t),
                n = a(r);
            if (e.href === n.href) return !0;
            if (e.host !== n.host || e.port !== n.port || e.protocol !== n.protocol || e.username !== n.username) return !1;
            var o = f(e.pathname, n.pathname),
                u = c(e.search, n.search);
            if (null === o || null === u) return !1;

            var i = _l(_l({}, o), u);

            return !Object.keys(i).length || i;
          }(r.pattern, n);

          return !1 !== e ? u(t, [{
            args: !0 === e ? {} : e,
            route: r
          }]) : t;
        }, []);
        if (0 === e.length) return t(Error("No routes found"));
        e[0].route.actions(e[0].args).then(function (t) {
          return r(t);
        });
      });
    }, i);

    function i(t) {
      void 0 === t && (t = {});
      var r = t.prefix,
          e = void 0 === r ? "" : r;
      this.prefix = e, this.routes = [];
    }

    var s = function s(t) {
      return void 0 === t && (t = {}), new o(t);
    };
  }], o.c = n, o.d = function (t, r, e) {
    o.o(t, r) || Object.defineProperty(t, r, {
      enumerable: !0,
      get: e
    });
  }, o.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, o.t = function (r, t) {
    if (1 & t && (r = o(r)), 8 & t) return r;
    if (4 & t && "object" == _typeof(r) && r && r.__esModule) return r;
    var e = Object.create(null);
    if (o.r(e), Object.defineProperty(e, "default", {
      enumerable: !0,
      value: r
    }), 2 & t && "string" != typeof r) for (var n in r) {
      o.d(e, n, function (t) {
        return r[t];
      }.bind(null, n));
    }
    return e;
  }, o.n = function (t) {
    var r = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return o.d(r, "a", r), r;
  }, o.o = function (t, r) {
    return Object.prototype.hasOwnProperty.call(t, r);
  }, o.p = "", o(o.s = 0);

  function o(t) {
    if (n[t]) return n[t].exports;
    var r = n[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return e[t].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
  }

  var e, n;
});